import { hideBootstrapModal } from "ws-app"

let userPrintPreferences = {
  showPlots: true,
  showNumericalResults: false
}

class PrintPreferencesComponent extends HTMLElement {

  constructor() {
    super()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-print-preferences-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Print Preferences</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <div class="form-check">
              <input type="checkbox" checked class="form-check-input" id="show-plots-print-preference-check">
              <label class="show-plots-print-preference-check">Include Plots</label>
            </div>

            <div class="form-check d-none">
              <input type="checkbox" checked class="form-check-input"
                id="show-numerical-results-print-preference-check">
              <label class="show-numerical-results-print-preference-check">Include Numerical Results</label>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                id="print-preferences-dialog-save-button">
                <i class="fa fa-fw fa-print"></i> Print
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById("print-preferences-dialog-save-button").addEventListener("click", function() {
      savePrintPreferences()
      printWithPreferences()
    })

    document.getElementById("show-plots-print-preference-check").checked = userPrintPreferences.showPlots;
    document.getElementById("show-numerical-results-print-preference-check").checked = userPrintPreferences.showNumericalResults;
  }
}

customElements.define('print-preferences-component', PrintPreferencesComponent)

function initializePrintPreferencesDialog() {
  document.getElementById("print-preferences-dialog-save-button").addEventListener("click", function() {
      savePrintPreferences();
      printWithPreferences();
  });

  updatePrintPreferencesDialogFields();
}

function savePrintPreferences() {
  userPrintPreferences.showPlots = document.getElementById("show-plots-print-preference-check").checked;
  userPrintPreferences.showNumericalResults = document.getElementById("show-numerical-results-print-preference-check").checked;
}

function printBeamDesign() {
  window.print()
  document.getElementById('modal-print-preferences-dialog').removeEventListener('hidden.bs.modal', printBeamDesign)
}

function printWithPreferences() {
  if(userPrintPreferences.showPlots) {
      document.getElementById("result-plots-div").classList.remove("hidden-print");
  } else {
      document.getElementById("result-plots-div").classList.add("hidden-print");
  }

  if(userPrintPreferences.showNumericalResults) {
      document.getElementById("numerical-results-div").classList.remove("hidden-print");
  } else {
      document.getElementById("numerical-results-div").classList.add("hidden-print");
  }

  hideBootstrapModal('modal-print-preferences-dialog')

  // add a temporary event listener to ensure that print preview does not include the modal backdrop
  document.getElementById('modal-print-preferences-dialog').addEventListener('hidden.bs.modal', printBeamDesign)    
}